type RowLike = Record<string, unknown>;

// Row that takes the removed row's place in the detail: the next survivor, else the nearest one before it.
export const getRowAfterRemoval = <T extends RowLike>(
  rows: T[],
  removedIds: string[],
  dataKey: string,
  removedRow: RowLike
): T | null => {
  if (!rows.length || !dataKey) return null;

  const removed = new Set(removedIds.map(String));
  const removedIndex = rows.findIndex(
    (row) => String(row[dataKey]) === String(removedRow[dataKey])
  );
  if (removedIndex === -1) return null;

  const next = rows
    .slice(removedIndex + 1)
    .find((row) => !removed.has(String(row[dataKey])));
  if (next) return next;

  const before = rows
    .slice(0, removedIndex)
    .filter((row) => !removed.has(String(row[dataKey])));

  return before[before.length - 1] ?? null;
};
